import React from "react";
import PropTypes from "prop-types";

import "./GoogleLoginButton.css";

export default class GoogleLoginButton extends React.Component {
  render() {
    return (
      <div
        style={{
          width: "100%",
          padding: "10px 20px"
        }}
      >
        <button className="googleSignInButton" onClick={this.props.onClick}>
          <img src={require("./assets/google_logo.png")} alt="Google Logo" />
          CONTINUE WITH GOOGLE
        </button>
      </div>
    );
  }
}

GoogleLoginButton.propTypes = {
  onClick: PropTypes.func
};
